import React from "react";
import { Modal, Typography } from "antd";
import { Box } from "@mui/material";
import { BarChart, LineChart, PieChart, ScatterChart } from "@mui/x-charts";
import Orbdatetypefiledsselector from "./Orbdatetypefiledsselector";

const { Title } = Typography;

const GraphHandler = ({
  open,
  onCancel,
  reportDates,
  setReportDates,
  selectedChart,
  setSelectedChart,
  selectedParameters,
  setSelectedParameters,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  fetchGraphData,
  timeFormat,
  setTimeFormat,
  transformedSeries,
  transformedXAxis,
  scatterSeries,
}) => {
  return (
    <Modal
      open={open}
      onCancel={onCancel}
      footer={null}
      width={1200}
      centered
      title="Oil Record Book Graph Analysis"
      bodyStyle={{ padding: 0 }}
    >
      {/* === FILTER SECTION === */}
      <Box sx={{ padding: 1, flex: 1 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: 2,
          }}
        >
          <Orbdatetypefiledsselector
            selectedDates={reportDates}
            setSelectedDates={setReportDates}
            selectedChart={selectedChart}
            setSelectedChart={setSelectedChart}
            selectedParameters={selectedParameters}
            setSelectedParameters={setSelectedParameters}
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            Graph_data={fetchGraphData}
            timeFormat={timeFormat}
            setTimeFormat={setTimeFormat}
          />
        </Box>

        {/* === CHART SECTION === */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            gap: "5px",
            marginTop: 2,
          }}
        >
          <Box
            sx={{
              width: "100%",
              height: "450px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Title level={5} style={{ textAlign: "center" }}>
              {selectedChart} Chart ({timeFormat})
            </Title>

            {selectedChart === "bar" && (
              <BarChart
                height={410}
                margin={{ bottom: 30, left: 60, right: 40 }}
                series={transformedSeries}
                xAxis={transformedXAxis}
                yAxis={[
                  {
                    valueFormatter: (value) =>
                      Number(value).toLocaleString("en-US", {
                        maximumFractionDigits: 1,
                      }),
                  },
                ]}
                slotProps={{
                  legend: { hidden: true },
                }}
              />
            )}

            {selectedChart === "line" && (
              <LineChart
                height={410}
                margin={{ bottom: 30, left: 40, right: 40 }}
                series={transformedSeries}
                xAxis={transformedXAxis}
                slotProps={{ legend: { hidden: true } }}
              />
            )}

            {selectedChart === "scatter" && (
              <ScatterChart
                height={410}
                margin={{ bottom: 30, left: 40, right: 40 }}
                series={scatterSeries}
                slotProps={{ legend: { hidden: true } }}
              />
            )}
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default GraphHandler;
